export function railsEnv() {
  return document.querySelector('meta[name="rails-env"]')?.content
}

// The frontend key reports into the production AppSignal app.
// Leave it off in development so local errors stay local.
export function frontendErrorsEnabled(env = railsEnv()) {
  return env !== "development"
}
